import { FC } from 'react'
import { useIntl } from 'react-intl'

import { RadioButtonGroupField, RadioButtonGroupFieldProps } from '@components/Form/RadioButtonGroup'

type Props = Omit<RadioButtonGroupFieldProps, 'options'>

const OPTIONS = [
  {
    label: 'vocabulary.yes',
    value: true,
  },
  {
    label: 'vocabulary.no',
    value: false,
  },
]

const YesNoRadioButtonGroupField: FC<Props> = (props) => {
  const intl = useIntl()

  const options = OPTIONS.map((opt) => ({
    label: intl.formatMessage({ id: opt.label }),
    value: opt.value,
  }))

  return (
    <RadioButtonGroupField
      {...props}
      options={options}
    />
  )
}

export default YesNoRadioButtonGroupField
